module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/bookcase/bookTexture1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/bookcase/bookTexture1.jpg
// module id = 521
// module chunks = 0